import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3722d44d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3722d44d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3722d44d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3722d44d')) {
      api.createRecord('3722d44d', component.options)
    } else {
      api.reload('3722d44d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3722d44d&scoped=true", function () {
      api.rerender('3722d44d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceManage/homeManage/invoiceRecord/index.vue"
export default component.exports